import React from "react";
import { Link, useLocation } from "react-router-dom";
import { CheckCircle, ArrowLeft, FilePdf, Printer, ChartLineUp } from "@phosphor-icons/react";
import { BACKEND_URL } from "../lib/api";

export default function RegisterSuccess() {
  const { state } = useLocation();
  const reg = state?.reg;
  const pdfUrl = reg?.form_token
    ? `${BACKEND_URL}/api/registrations/form/${reg.form_token}/pdf`
    : null;
  const trackUrl = reg?.form_token ? `/track/${reg.form_token}` : null;

  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-6">
      <div className="max-w-xl w-full sms-fade-up">
        <div className="border border-slate-900 p-10">
          <CheckCircle size={48} weight="duotone" className="text-[var(--sms-success)] mb-6" />
          <div className="font-mono-sms text-xs uppercase tracking-[0.3em] text-[var(--sms-primary)] mb-3">
            Application Received
          </div>
          <h1 className="font-display text-4xl font-black tracking-tighter mb-4">
            We've got it. Sit tight.
          </h1>
          <p className="text-slate-700 mb-6">
            Your application is now in the registrar's queue. We'll reach out on the phone number you provided once your application is reviewed. Approved applicants are issued an automatic Student ID.
          </p>
          {reg && (
            <div className="bg-slate-50 border border-slate-200 p-4 mb-6">
              <div className="font-mono-sms text-[10px] uppercase tracking-[0.2em] text-slate-500 mb-1">
                Reference
              </div>
              <div className="font-mono-sms text-sm" data-testid="reg-reference">
                {reg.id}
              </div>
            </div>
          )}

          {trackUrl && (
            <div className="border border-[var(--sms-primary)]/30 bg-[var(--sms-primary)]/5 p-4 mb-4">
              <div className="font-mono-sms text-[10px] uppercase tracking-[0.2em] text-[var(--sms-primary)] mb-2 inline-flex items-center gap-2">
                <ChartLineUp size={12} weight="duotone" /> Bookmark this link
              </div>
              <p className="text-sm text-slate-700 mb-3">
                Track your application status, payment, and placement progress at any time.
              </p>
              <Link
                to={trackUrl}
                data-testid="btn-open-tracker"
                className="sms-btn-primary inline-flex items-center gap-2"
              >
                <ChartLineUp size={16} weight="duotone" /> Open my tracker
              </Link>
            </div>
          )}

          {pdfUrl && (
            <div className="border border-slate-200 p-4 mb-8">
              <div className="font-mono-sms text-[10px] uppercase tracking-[0.2em] text-[var(--sms-primary)] mb-2">
                Application copy
              </div>
              <p className="text-sm text-slate-600 mb-3">
                Save a PDF copy of what you submitted for your records.
              </p>
              <div className="flex flex-wrap items-center gap-2">
                <a
                  href={pdfUrl}
                  download={`application-${(reg.full_name || "applicant").replace(/\s+/g, "_")}.pdf`}
                  data-testid="btn-download-form-pdf"
                  className="sms-btn-primary inline-flex items-center gap-2"
                >
                  <FilePdf size={16} weight="duotone" /> Download PDF
                </a>
                <a
                  href={pdfUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="btn-print-form-pdf"
                  className="sms-btn-secondary inline-flex items-center gap-2"
                >
                  <Printer size={16} weight="bold" /> Open & print
                </a>
              </div>
            </div>
          )}

          <Link to="/" data-testid="success-home-link" className="sms-btn-secondary inline-flex items-center gap-2">
            <ArrowLeft size={16} weight="bold" /> Return home
          </Link>
        </div>
      </div>
    </div>
  );
}
